import { schema } from "normalizr";
import { task } from "./schema.tasks.jsx";

const subtask = new schema.Entity(`subtasks`);
const arrayOfSubtasks = [subtask];

subtask.define({
  task,
});

export { subtask, arrayOfSubtasks };
